import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getOrderDetailsRequest, clearOrderDetails } from 'redux/reducers/euDdp/reducer';
import { Page } from 'layouts/Page';
import { EuDdpOrder } from 'components/EuDdpOrders/EuDdpOrder';

export const EuDdpOrderDetailPage: FC = () => {
	const { orderId } = useParams<{ orderId: string }>();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!orderId) return;
		dispatch(getOrderDetailsRequest({ orderId: Number(orderId) }));
		return () => {
			dispatch(clearOrderDetails());
		};
	}, [dispatch, orderId]);

	return (
		<Page title={`EU DDP Order ${orderId ?? ''} – EAS Control Center`}>
			<EuDdpOrder />
		</Page>
	);
};
